<template>
    <div class="box" @click="handleClickClose" v-if="showUserDialog">
        <div class="box-image">
            <p class="title">完善信息提示</p>
            <p class="desc" style="margin-bottom: 0">你还没有{{showUserDialogText || '社区昵称和身份'}}哦，</p>
            <p class="desc">设置一下让小伙伴更容易记住你～</p>
            <div class="btn" @click.stop="toSetting">

            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapState, mapMutations} from 'vuex'
      export default {
        name: "w-user-dialog",
        computed:{
            ...mapState("user",['showUserDialog', 'showUserDialogText'])
        },
        methods:{
            ...mapMutations('user',['setShowUserDialog']),
            handleClickClose(){
                this.setShowUserDialog(false)
            },
            toSetting(){
                this.setShowUserDialog(false)
                this.$router.push('/account/users/vue_basic_info')
            }
        }
      }
</script>

<style scoped>
      .box{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.5);
        z-index: 99999;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    .box-image{
        width: 271px;
        height: 291px;
        background: url("https://files.wondercv.com/rn/identity/identity.png");
        background-size: 100%;
        padding: 129px 24px 0;
    }
    .title{
        text-align: center;
        line-height: 22px;
        color: #404040;
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 12px;
    }
    .desc{
        text-align: center;
        line-height: 22px;
        color: #606060;
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 24px;
    }
    .btn{
        margin: 0 auto;
        width: 153px;
        height: 36px;
    }

</style>